import { render } from "./ConditionItem.vue?vue&type=template&id=c1f1800e&scoped=true"
import script from "./ConditionItem.vue?vue&type=script&lang=ts"
export * from "./ConditionItem.vue?vue&type=script&lang=ts"

import "./ConditionItem.vue?vue&type=style&index=0&id=c1f1800e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c1f1800e"

export default script
import QSelect from 'quasar/src/components/select/QSelect.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QChip,QInput,QBtn,QField});
